import styled from 'styled-components';
import { animations } from '../animations';

export const Backdrop = styled.div`
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${animations.fadeIn} 0.2s ease forwards;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.primary.white};
  width: 30rem;
  max-width: 100vw;
  max-height: 90vh;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  margin-left: 24px;
  margin-bottom: 8px;
`;

export const Title = styled.h3`
  flex: 1;
  margin: 0;
  line-height: 50px;
  font-size: 1rem;

  line-height: 1;
  overflow-y: auto;
  height: 100%;
  padding: 4px 0;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  padding: 8px 24px 24px 24px;
  max-height: calc(90vh - 58px);
`;

export const SquareButton = styled.button`
  height: 50px;
  width: 50px;
  border: 0;
  outline: 0;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  cursor: pointer;

  &:hover {
    filter: brightness(0.9);
  }

  & svg {
    height: 50%;
    & > path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;
